import axios from "axios"
import qs from "qs"

/**
 * HTTP клиент
 */
export default class HttpClient {
	/**
	 * Инициализировать HTTP клиент
	 * @param {Object} config
	 */
	constructor(config) {
		config = config || {}

		this.baseUrl = config.baseUrl || null
		this.token = config.token || null
	}

	/**
	 * Получить глобальне опции запросов
	 * @return {Object}
	 */
	get options() {
		return {
			baseURL: this.baseUrl,
			responseType: "json",
			headers: {
				"X-Auth-Token": this.token instanceof Function ? this.token.call(null) : this.token,
				"X-Requested-With": "XMLHttpRequest"
			}
		}
	}

	/**
	 * Установить токен
	 * @param {String|null}
	 */
	// setToken(token) {
	// 	this.token = token
	// }

	/**
	 * Парсить параметр URL
	 * @param {String|Array} schema
	 */
	parseUrl(schema) {
		if (schema instanceof Array) {
			return {
				url: schema[0] || "",
				params: schema[1] || {}
			}
		}

		if (schema instanceof Object) {
			return {
				url: schema.url || "",
				params: schema.params || {}
			}
		}

		return {
			url: schema || "",
			params: {}
		}
	}

	/**
	 * Нормализовать заголовки
	 * @param {Object} headers
	 * @return {Object}
	 */
	normalizeHeaders(headers) {
		headers = { ...headers }

		if (headers.token) {
			headers["X-Auth-Token"] = headers.token
			delete headers.token
		}

		return headers
	}

	/**
	 * Создать HEAD запрос
	 * @param {String|Object} url URL адрес запроса
	 * @param {Object} headers заголовки запроса
	 */
	async head(url, headers = {}) {
		const response = await this.request("head", url, {}, headers, { fullReponse: true })

		return response.headers
	}

	/**
	 * Создать GET запрос
	 * @param {String|Object} url URL адрес запроса
	 * @param {Object} headers заголовки запроса
	 */
	async get(url, headers = {}) {
		return await this.request("get", url, {}, headers)
	}

	/**
	 * Создать POST запрос
	 * @param {String|Object} url URL адрес запроса
	 * @param {Object} data тело запроса (JSON)
	 * @param {Object} headers заголовки запроса
	 */
	async post(url, data = {}, headers = {}) {
		return await this.request("post", url, data, headers)
	}

	/**
	 * Создать PUT запрос
	 * @param {String|Object} url URL адрес запроса
	 * @param {Object} data тело запроса (JSON)
	 * @param {Object} headers заголовки запроса
	 */
	async put(url, data = {}, headers = {}) {
		return await this.request("put", url, data, headers)
	}

	/**
	 * Создать DELETE запрос
	 * @param {String|Array} url URL адрес запроса
	 * @param {Object} data тело запроса (JSON)
	 * @param {Object} headers заголовки запроса
	 */
	async delete(url, data = {}, headers = {}) {
		return await this.request("delete", url, data, headers)
	}

	/**
	 * Создать запрос
	 * @param {String} method метод запроса
	 * @param {String|Array} schema URL адрес запроса (может быть массивом)
	 * @param {Object} params GET параметры
	 * @param {Object} data тело запроса (JSON)
	 * @param {Object} headers заголовки запроса
	 * @param {Object} options дополнительные опции
	 */
	async request(method, schema, data = {}, headers = {}, options = {}) {
		const { url, params } = this.parseUrl(schema)

		headers = this.normalizeHeaders({ ...this.options.headers, ...headers })
		options = {
			// Глобальные опции
			...this.options,

			// Системные опции
			method,
			url,
			headers,
			params,
			data,
			paramsSerializer: params => qs.stringify(params, { skipNulls: true, encodeValuesOnly: true }),

			// Локальные опции
			...options
		}

		try {
			const response = await axios(options)

			return options.fullReponse ? response : response.data
		} catch ({ response }) {
			throw options.fullErrorReponse ? response : response.data
		}
	}
}
